/**
 * @generated SignedSource<<d8bc8d6ef5123295d68fc06a896cdd90>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs, Result } from "relay-runtime";
export type useEditorContentTypesHeaderFragment_content$data = Result<{
  readonly draftVersion: {
    readonly by: {
      readonly displayName: string | null;
    } | null;
    readonly contentTypeModified: boolean | null;
    readonly friendlyWhen: string | null;
    readonly number: number | null;
    readonly when: string | null;
  } | null;
  readonly id: string | null;
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly smartFolderProperties: {
    readonly nodes: ReadonlyArray<{
      readonly key: string | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly space: {
    readonly alias: string | null;
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
  } | null;
  readonly status: string | null;
  readonly subType: string | null;
  readonly title: string | null;
  readonly type: string | null;
  readonly version: {
    readonly by: {
      readonly displayName: string | null;
    } | null;
    readonly contentTypeModified: boolean | null;
    readonly friendlyWhen: string | null;
    readonly number: number | null;
    readonly when: string | null;
  } | null;
  readonly " $fragmentType": "useEditorContentTypesHeaderFragment_content";
}, unknown>;
export type useEditorContentTypesHeaderFragment_content$key = {
  readonly " $data"?: useEditorContentTypesHeaderFragment_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"useEditorContentTypesHeaderFragment_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "key"
},
v2 = [
  {
    "kind": "ScalarField",
    "name": "contentTypeModified"
  },
  {
    "kind": "ScalarField",
    "name": "number"
  },
  {
    "kind": "ScalarField",
    "name": "friendlyWhen"
  },
  {
    "kind": "LinkedField",
    "name": "by",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "displayName"
      }
    ]
  },
  {
    "kind": "ScalarField",
    "name": "when"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "catchTo": "RESULT"
  },
  "name": "useEditorContentTypesHeaderFragment_content",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    },
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "ScalarField",
          "name": "name"
        },
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "alias"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "alias": "smartFolderProperties",
      "args": [
        {
          "kind": "Literal",
          "name": "keys",
          "value": [
            "smartFolderProperties"
          ]
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v1/*: any*/),
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ],
      "storageKey": "properties(keys:[\"smartFolderProperties\"])"
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": (v2/*: any*/)
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "draftVersion",
      "plural": false,
      "selections": (v2/*: any*/)
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "d75e20775dfddcb051140ced8c9ea8fd";

export default node;
